<template>
    <div>
        <div>homeBottom</div>
    </div>
</template>

<script>
export default {
    name: "HomeBottom",
    props: {

    },
    data() {
        return {

        };
    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
};
</script>
<style scoped lang='scss'>

</style>
